/* Speed: animated GIFs are 1 to 13 MB each, so none of them load up front.
   1. GIFs rendered by snippets/media.liquid (slideshow, gallery, image sections)
      ship as their static first frame (format=pjpg) marked data-gif-static.
      After page load the format param is stripped so the animation plays.
      Lazy images keep loading="lazy", so off-screen ones still wait for scroll.
   2. Product card hover GIFs (snippets/product-card.liquid) carry data-hover-src /
      data-hover-srcset and load on first hover of their card (mouse only). */
(function () {
  var STATIC_PARAM = /([?&])format=pjpg&?/g;

  function unstatic(value) {
    return value ? value.replace(STATIC_PARAM, '$1').replace(/[?&](\s|$)/g, '$1') : value;
  }

  function swapAnimated() {
    document.querySelectorAll('[data-gif-static]').forEach(function (el) {
      el.removeAttribute('data-gif-static');
      if (el.getAttribute('srcset')) el.setAttribute('srcset', unstatic(el.getAttribute('srcset')));
      if (el.tagName === 'IMG' && el.getAttribute('src')) el.setAttribute('src', unstatic(el.getAttribute('src')));
    });
  }

  function afterLoad() {
    var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 1); };
    setTimeout(function () { idle(swapAnimated, { timeout: 3000 }); }, 1500);
  }

  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

  document.addEventListener('pointerover', function (event) {
    var figure = event.target.closest && event.target.closest('.product-card__figure');
    if (!figure) return;

    var img = figure.querySelector('img[data-hover-src]:not([data-hover-loading])');
    if (!img) return;

    img.setAttribute('data-hover-loading', '');
    img.addEventListener('load', function () {
      img.removeAttribute('data-hover-src');
    }, { once: true });

    img.loading = 'eager';
    if (img.dataset.hoverSrcset) img.srcset = img.dataset.hoverSrcset;
    img.src = img.dataset.hoverSrc;
  }, { passive: true });
})();
